import { Box, Text } from "@chakra-ui/react";
import React, { useEffect, useRef } from "react";
import Sphere from "./Sphere";

const SkillCard = ({ title, text1 = null, text2 = null }) => {
  const skillCardRef = useRef(null);
  useEffect(() => {
    if (skillCardRef.current) {
      const timer = setTimeout(() => {
        const canvas = skillCardRef.current.getElementsByTagName("canvas");
        if (canvas.length > 1) {
          canvas[1].remove();
        }
      }, [2000]);
      return () => clearTimeout(timer);
    }
  }, [skillCardRef]);

  return (
    <Box
      display="flex"
      flexDir="column"
      justifyContent="center"
      alignItems="center"
    >
      {/* title */}
      <Box
        mx="auto"
        w="min-content"
        bg="rgba(45,212,191,0.1)"
        p="0.25rem 0.75rem"
        borderRadius="0.5rem"
      >
        <Text
          as="h2"
          fontSize="1.5rem"
          lineHeight="1.6"
          fontWeight="500"
          color="rgb(94,234,212)"
          letterSpacing="1px"
        >
          {title}
        </Text>
      </Box>
      <Box ref={skillCardRef}>
        {skillCardRef && (
          <Sphere parentRef={skillCardRef} text1={text1} text2={text2} />
        )}
      </Box>
    </Box>
  );
};

export default SkillCard;
